export default
{
    name: 'app-icon-arrow',

    props:
    {
        color: { type: String, default: 'white' }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-icon-external/script.js